import * as React from "react";
import { useScreenContext } from "./screenContext";

import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { Button } from "@mui/material";

export default function Logout(props) {
  const { initLogout } = useScreenContext();

  return (
    <Button
      variant="text"
      className="logout-button"
      onClick={() => initLogout()}
      sx={{
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "14px",
        height: "35px",
        textTransform: "none",
        color: "#333",
        backgroundColor: "none",
      }}
    >
      <span style={{ marginRight: "5px" }}>{props.user ? props.user?.current_user?.name : "Logout"}</span>
      <LogoutRoundedIcon fontSize="14" />
    </Button>
  );
}
